module.exports = __webpack_public_path__ + "img/tamtech_full.d2b5031b.png";